module.exports = __webpack_public_path__ + "img/psychotechnical.c72ac7f7.svg";